<template>
  <div class="page">
    <header-bar slot="head">
      <span slot="left">{{ $t("mall_modules_editrole_fanhui") }}</span>
      <span>{{ $t(objSave.centerTitle) }}</span>
    </header-bar>
    <div class="page-content">
      <div class="about">
        <img :src="getImgs('Aboutus1.png')" style="width:100%;" />
        <img :src="getImgs('Aboutus2.png?1')" style="width:100%;" />
      </div>
    </div>
  </div>
</template>
<style scoped>
  .about {
    font-size: 0;
  }

  .header-menu header {
    background-color: #12a3ff;
  }

  .page-content {
    top: 2.12rem;
  }
/* 
  .about-wrapper {
    font-size: 0.399rem;
    padding: 0 0.399rem;
  }

  .about-title {
    padding: 0.133rem 0 0.266rem 0;
    color: #ff8800;
  }

  .about-content {
    text-indent: 0.798rem;
    color: #808080;
    padding-bottom: 0.399rem;
  } */
</style>
<script>
  export default {
    name: "about",
    data() {
      return {
        objSave: {
          centerTitle: "system.AboutUs",
        },
      };
    },
  };
</script>
